module.exports = __webpack_public_path__ + "static/news-8f4073f87b2325b973f3d97ed2c64a59.png";